// /*
//  * Broadcast Theme
//  *
//  * Use this file to add custom Javascript to Broadcast.  Keeping your custom
//  * Javascript in this fill will make it easier to update Broadcast. In order
//  * to use this file you will need to open layout/theme.liquid and uncomment
//  * the custom.js script import line near the bottom of the file.
//  */

// // 13-Dec-2024 Popup Cookie
// class PopupCookie {
//   constructor(name, value, daysToExpire = 7) {
//     const today = new Date();
//     const expiresDate = new Date();
//     expiresDate.setTime(today.getTime() + 3600000 * 24 * daysToExpire);

//     this.configuration = {
//       expires: expiresDate.toGMTString(),
//       path: "/",
//       domain: window.location.hostname,
//       sameSite: "none",
//       secure: true,
//     };
//     this.name = name;
//     this.value = value;
//   }

//   write() {
//     const hasCookie =
//       document.cookie.indexOf("; ") !== -1 &&
//       !document.cookie.split("; ").find((row) => row.startsWith(this.name));

//     if (hasCookie || document.cookie.indexOf("; ") === -1) {
//       document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
//     }
//   }

//   read() {
//     if (
//       document.cookie.indexOf("; ") !== -1 &&
//       document.cookie.split("; ").find((row) => row.startsWith(this.name))
//     ) {
//       const returnCookie = document.cookie
//         .split("; ")
//         .find((row) => row.startsWith(this.name))
//         .split("=")[1];
//       return returnCookie;
//     } else {
//       return false;
//     }
//   }
// }
// function checkCookie() {
//   const cookie = new PopupCookie("userConsent", "true");
//   return cookie.read();
// }
// $("#setCookieButton,#NosetCookieButton").on("click", function () {
//   const cookie = new PopupCookie("userConsent", "true", 7);
//   cookie.write();
//   $(".popup-cookies").hide();
// });

// if (checkCookie()) {
//   $(".popup-cookies").hide();
// } else {
//   $(".popup-cookies").show();
//   $("div#Popup--popups-0").attr("style", "display: block !important;");
// }
// // 13-Dec-2024 Popup Cookie

// $("body")
//   .on("mouseenter", ".collection-image", function () {
//     var image = $(this).attr("data-image");
//     var title = $(this).attr("data-title");
//     if (typeof image === "undefined") {
//       $(".visibility-div").removeClass("image-found");
//     } else {
//       $(".visibility-div").addClass("image-found");
//       $(".visibility-div img").attr("src", image);
//       $(".visibility-div .navlink span").html(title);
//     }
//   })
//   .on("mouseleave", "div", function () {
//     $(".visibility-div").removeClass("image-found");
//     $(".visibility-div img").attr("src", "");
//     $(".visibility-div .navlink span").html("");
//   });
// // product see chart start
// $("body").on("click", "span.custom_see_chart_jtpl", function () {
//   $(".custom_see_chart_table_wrapper").show();
//   $("body").addClass("product_see_chart_open");
// });
// $("body").on("click", "svg.custom_pdp_cross_icon_jtpl", function () {
//   $(".custom_see_chart_table_wrapper").hide();
//   $("body").removeClass("product_see_chart_open");
// });
// $("body").on("click", ".inner_body_close", function () {
//   $("body").removeClass("product_see_chart_open");
//   $(".custom_see_chart_table_wrapper").hide();
// });


// $(".sibling__link_btn").click(function () {
//   $(".sibling__link_btn").removeClass("sibling__link--current");
//   $(this).addClass("sibling__link--current");
//   var isPreorder = $(this).data("preorder");
//   var productId = $(this).data("id");
//    $(".product_id_change").val(productId);
//   var estimateText = $(this).data("estimateShippingText");
//    updatePreorderFromSwatch($(this));

//       setTimeout(() => {
//       updateRebuy(productId);
//     }, 100);

//   const handle = $(this).data("handle");

//     fetch(`/products/${handle}?view=gallery`)
//     .then(r => r.text())
//     .then(html => {
//       const $html = $(html);
//       const $newGallery = $html.find(".custom_product__images");

//       const $currentGallery = $(".custom_product__images");
//       if ($currentGallery.find(".slick-initialized").length) {
//         $currentGallery.find(".slick-initialized").slick("unslick");
//       }

//       $currentGallery.replaceWith($newGallery);
//       initProductSlider();
//     });

   


//   var ComparepriceMoney = $(this).attr("data-compare-without-money");
//   var ProductriceMoney = $(this).attr("data-without-money");

//   var getReviews = $(this).attr("data-review");
//   var getpReviews = $(this).attr("data-preview");
//   var getDesc = $(this).attr("data-desc");
  
// $(".product-accordion .accordion:eq(0) .accordion-content__entry").html(getDesc);
//   var upsellTitle = $(this).attr("data-upsellTitle");
//   var upsellPrice = $(this).attr("data-upsellPrice");
//   var upsellid = $(this).attr("data-upsellid");
//   var upsellImg = $(this).attr("data-upsellImg");
//   var upsellHanle = $(this).attr("data-upsellHanle");
//   var dataCutline = $(this).data("cutline");
//   var dataUrl = $(this).data("url");
//   var producttitle = $(this).data("title");
//   var productPrice = $(this).data("price");
//   var productId = $(this).data("id");
//   var productComapreprice = $(this).attr("data-compare-price");
//   if (productComapreprice == "") {
//     $("s.product__price--strike").hide();
//     $("span.product__price--off").hide();
//     $("span.product__price--sale").css("color", "#212121");
//   } else {
//     $("s.product__price--strike").show();
//     $("span.product__price--off").show();
//     $("span.product__price--sale").css("color", " #d30808");

//     var getPercentage = Math.floor(
//       ((ComparepriceMoney - ProductriceMoney) * 100) / ComparepriceMoney
//     );

//     $("span.product__price--off").text(`${getPercentage}% OFF`);
//     $(".product__price--off").removeClass("hidden");
//     $(".product__block .product__price").html(
//       `<span data-product-price="" class="product__price--sale">${productPrice}</span><span class="visually-hidden" data-compare-text="">Regular price</span><s class="product__price--strike" data-compare-price="">
//       ${productComapreprice}</s>`
//     );
//   }
//   $(".p_upsell_link").attr("href", upsellHanle);
//   $(".upsell_id").val(upsellid);
//   $(".product-upsell__image__thumb figure img").attr("srcset", upsellImg);
//   $(".product-upsell__image__thumb figure img").attr("src", upsellImg);
//   $(".new-price").text(upsellPrice);
//   $(".product-upsell__title").text(upsellTitle);
//   $(".product__title").text(producttitle);
//   $(".product__title_bread").text(producttitle);
//   $(".review_div").html(" ");
//   $(".review_div").html(getReviews);
//   $(".product-summary").html(" ");
//   $(".product-summary").html(getpReviews);
//   $(".radio__legend__value").text(dataCutline);
//   $(".dataCutline").val(dataCutline);
//   $(".cart-bar__product__title").text(producttitle);
//   $(".product__price span").text(productPrice);
//   $(".product_id_change").val(productId);
//   $(".product__description__content__entry").html(getDesc);


//   window.history.pushState("page2", "Title", "/products/" + dataUrl);
// });

// $("body").on("click", ".main_sub_menu", function () {
//   var menuClass = $(this).attr("data-menu");
//   $(".sub-menu.jtpl-" + menuClass).slideToggle();
//   $(this).toggleClass("arrow-show");
// });
// var getAttrtrue = $(".index-product.section-padding").attr(
//   "data-sticky-enabled"
// );
// console.log(getAttrtrue);
// if (getAttrtrue == "true") {
//   $(".product__page .form__wrapper").addClass("is-sticky");
// } else {
//   $(".product__page .form__wrapper").removeClass("is-sticky");
// }

//         function initProductSlider() {
//         var $slider = $(".custom_product__images.product__images--has-thumbs .product__slides");
      
//         if ($slider.length > 0) {
//           // Check if screen is mobile
//           if ($(window).width() < 767) { $(".product__page .form__wrapper").removeClass("is-sticky");

//             // Initialize only if not already initialized
//             if (!$slider.hasClass("slick-initialized")) {
//               $slider.slick({
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 autoplay: false,
//                 fade: true,
//                 adaptiveHeight: true,
//               });
//             }
//           } else {
//             // If desktop and slick initialized, destroy it
//             if ($slider.hasClass("slick-initialized")) {
//               $slider.slick("unslick");
//             }
//           }
//         }
//       }
      
//       // Initialize on page load
//       $(document).ready(function() {
//         initProductSlider();
//       });
      
//       // Reinitialize on window resize
//       $(window).on("resize", function() {
//         initProductSlider();
//       });

// if ($(window).width() < 767) {

// } else {
//   // $('.custom_product__images.product__images--has-thumbs .product__slides').unslick();
// }
// (function () {
//   // Add custom code below this line

//   $("body").on("click", ".product__thumb .product__thumb__link", function (e) {
//     e.preventDefault();

//     var getThumbimage = $(this).attr("data-med-id");
//     //console.log(getThumbimage);

//     $(".custom_product__images .product__slide").each(function () {
//       var getProductId = $(this).attr("data-image-id");

//       // Check if the IDs match
//       if (getProductId == getThumbimage) {
//         var gteSlickIndex = $(this).attr("data-slick-index");
//         console.log(gteSlickIndex);

//         $(
//           ".custom_product__images.product__images--has-thumbs .product__slides"
//         ).slick("slickGoTo", parseInt(gteSlickIndex)); 
//       }
//     });
//   });

// })();

// $(document).on("click", "#second_search .icon.icon-search", function(){
//     $("body").addClass("search-overlay-new");
// });

// $(document).on("click", ".search-popdown__close__button", function() {
//     setTimeout(function() {
//         $("body").removeClass("search-overlay-new");
//     }, 500); 
// });

// window.addEventListener('scroll', () => {
//   const section = document.getElementById('BrickSection--template--18874880688303__section_custom_content_QFwrg6');
//   const header = document.querySelector('.header__wrapper.js__header__stuck.js__header__stuck__backdrop');

//   if (!section || !header) return;

//   const sectionRect = section.getBoundingClientRect();

//   if (sectionRect.bottom <= 0) {
//     header.classList.add('new-header-transparent');
//     header.removeAttribute("data-header-transparent");
   
//     header.setAttribute("data-header-transparent", "false");
//   } else {
//     header.classList.remove('new-header-transparent');
//     header.setAttribute("data-header-transparent","true");
//   }

// });

// $(document).ready(function () {
//   if ($(window).width() < 758) {
//     var headerHeight = $("header.theme__header").height();

//   }
//   if ($(window).width() < 684) {
//     $(document).on("click", ".sliderule__wrapper", function (e) {
//       e.stopPropagation();
//       $(this).find("ul.sub-menu.drop-down").css("display", "block");
//     });
//   }
//   document.querySelectorAll('body *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6)').forEach(el => {
//   const text = el.textContent.trim();
//   if (text && text === text.toUpperCase()) {
//     console.log("UpperCase");
//     el.classList.add('uppercase-auto');
//   }
// });
// });



// //feb 4 jtpl
// function applyPreorderState({
//   preorder = false,
//   available = true,
//   preorderText = "Pre Order",
//   estimateShippingText = ""
// }) {
//   const submitBtn = document.querySelector('.product-form button[type="submit"]');
//   const btnTextEl = submitBtn?.querySelector('[data-atc-text], .btn__text_cstm');

//   const preorderInput = document.getElementById('preorder-input');
//   const estimateInput = document.getElementById('estimate-input');
//   const estimateWrapper = document.querySelector('.custom_preorder_text_product_wrapper');
//   const estimateTextEl = document.querySelector('.estimate-shipping-text');

//   if (!submitBtn || !btnTextEl) return;

//   /* RESET */
//   submitBtn.disabled = false;
//   submitBtn.dataset.preorder = "false";
//   btnTextEl.textContent = "Add to Cart";

//   if (preorderInput) preorderInput.value = "";
//   if (estimateInput) estimateInput.value = "";

//   if (estimateWrapper) estimateWrapper.style.display = "none";
//   if (estimateTextEl) estimateTextEl.textContent = "";

//   /* SOLD OUT */
//   if (!available) {
//     btnTextEl.textContent = "Sold Out";
//     submitBtn.disabled = true;
//     return;
//   }

//   /* PREORDER */
//   if (preorder) {
//     btnTextEl.textContent = preorderText || "Pre Order";
//     submitBtn.dataset.preorder = "true";

//     if (preorderInput) preorderInput.value = "Yes";
//     if (estimateInput) estimateInput.value = estimateShippingText || "";

//     if (estimateWrapper && estimateTextEl && estimateShippingText) {
//       estimateTextEl.textContent = estimateShippingText;
//       estimateWrapper.style.display = "block";
//     }
//   }
// }


// $(document).ready(function () {
//   const initialDataEl = document.getElementById("initial-product-data");

//   if (initialDataEl) {
//     const data = JSON.parse(initialDataEl.textContent);
//     applyPreorderState(data);
//   }
// });

// function updatePreorderFromSwatch($el) {
//   applyPreorderState({
//     preorder: $el.attr("data-preorder") === "true",
//     available: $el.attr("data-available") === "true",
//     preorderText: $el.attr("data-pre-order-text"),
//     estimateShippingText: $el.attr("data-estimate-shipping-text")
//   });
// }
// //end-feb 4 jtpl

// // function updatePreorderFromSwatch($el) {
// //   const preorder = $el.attr("data-preorder") === "true";
// //   const available = $el.attr("data-available") === "true";
// //   const preorderText = $el.attr("data-pre-order-text") || "Pre Order";
// //   const estimateShippingText = $el.attr("data-estimate-shipping-text");

// //   const submitBtn = document.querySelector('.product-form button[type="submit"]');
// //   const preorderInput = document.getElementById('preorder-input');
// //   const estimateInput = document.getElementById('estimate-input');
// //   const estimateWrapper = document.querySelector('.custom_preorder_text_product_wrapper');
// //   const estimateTextEl = document.querySelector('.estimate-shipping-text');

// //   if (!submitBtn) return;


// //   submitBtn.disabled = false;
// //   submitBtn.dataset.preorder = "false";
// //   submitBtn.textContent = "Add to Cart";

// //   if (preorderInput) preorderInput.value = "";
// //   if (estimateInput) estimateInput.value = "";
// //   if (estimateWrapper) estimateWrapper.style.display = "none";

// //    if (!available) {
// //     submitBtn.textContent = "Sold Out";
// //     submitBtn.disabled = true;
// //     return;
// //   }


// //   if (preorder) {
// //     submitBtn.textContent = preorderText;
// //     submitBtn.dataset.preorder = "true";

// //     if (preorderInput) preorderInput.value = "Yes";
// //     if (estimateInput) estimateInput.value = estimateShippingText || "";

// //     if (estimateWrapper && estimateTextEl && estimateShippingText) {
// //       estimateTextEl.textContent = estimateShippingText;
// //       estimateWrapper.style.display = "block";
// //     }
// //     return;
// //   }

// //   submitBtn.textContent = "Add to Cart";
// // }



// // $(document).ready(function () {
// //   const $currentSwatch = $(".sibling__link_btn.sibling__link--current");
// //   if ($currentSwatch.length) {
// //     updatePreorderFromSwatch($currentSwatch);
// //   }
// // });



// function updateRebuy(productId) {
//   if (
//     window.Rebuy &&
//     window.Rebuy.widgets &&
//     typeof window.Rebuy.widgets.update === "function"
//   ) {
//     window.Rebuy.widgets.update({
//       productId: productId
//     });
//   }
// }



/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
// 13-Dec-2024 Popup Cookie
class PopupCookie {
  constructor(name, value, daysToExpire = 7) {
    const today = new Date();
    const expiresDate = new Date();
    expiresDate.setTime(today.getTime() + 3600000 * 24 * daysToExpire);
    this.configuration = {
      expires: expiresDate.toGMTString(),
      path: "/",
      domain: window.location.hostname,
      sameSite: "none",
      secure: true,
    };
    this.name = name;
    this.value = value;
  }
  write() {
    const hasCookie =
      document.cookie.indexOf("; ") !== -1 &&
      !document.cookie.split("; ").find((row) => row.startsWith(this.name));
    if (hasCookie || document.cookie.indexOf("; ") === -1) {
      document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
    }
  }
  read() {
    if (
      document.cookie.indexOf("; ") !== -1 &&
      document.cookie.split("; ").find((row) => row.startsWith(this.name))
    ) {
      const returnCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith(this.name))
        .split("=")[1];
      return returnCookie;
    } else {
      return false;
    }
  }
}
function checkCookie() {
  const cookie = new PopupCookie("userConsent", "true");
  return cookie.read();
}
$("#setCookieButton,#NosetCookieButton").on("click", function () {
  const cookie = new PopupCookie("userConsent", "true", 7);
  cookie.write();
  $(".popup-cookies").hide();
});
if (checkCookie()) {
  $(".popup-cookies").hide();
} else {
  $(".popup-cookies").show();
  $("div#Popup--popups-0").attr("style", "display: block !important;");
}
// 13-Dec-2024 Popup Cookie
// $("body")
//   .on("mouseenter", ".collection-image", function () {
//     var image = $(this).attr("data-image");
//     var title = $(this).attr("data-title");
//     if (typeof image === "undefined") {
//       $(".visibility-div").removeClass("image-found");
//     } else {
//       $(".visibility-div").addClass("image-found");
//       $(".visibility-div img").attr("src", image);
//       $(".visibility-div .navlink span").html(title);
//     }
//   })
//   .on("mouseleave", "div", function () {
//     $(".visibility-div").removeClass("image-found");
//     $(".visibility-div img").attr("src", "");
//     $(".visibility-div .navlink span").html("");
//   });


// 1. "div" ki jagah specific selector use karein (.collection-image)
// 2. Element existence check (length > 0) add kiya hai
$("body")
  .on("mouseenter", ".collection-image", function () {
    var image = $(this).attr("data-image");
    var title = $(this).attr("data-title");
    
    var $visibilityDiv = $(".visibility-div");
    
    if ($visibilityDiv.length > 0) {
      if (typeof image === "undefined" || image === "") {
        $visibilityDiv.removeClass("image-found");
      } else {
        $visibilityDiv.addClass("image-found");
        $visibilityDiv.find("img").attr("src", image);
        $visibilityDiv.find(".navlink span").html(title);
      }
    }
  })
  .on("mouseleave", ".collection-image", function () {
    var $visibilityDiv = $(".visibility-div");
    
    // Check lagaya taaki 'removeClass' ka error na aaye
    if ($visibilityDiv.length > 0) {
      $visibilityDiv.removeClass("image-found");
      $visibilityDiv.find("img").attr("src", "");
      $visibilityDiv.find(".navlink span").html("");
    }
  });

// product see chart start
$("body").on("click", "span.custom_see_chart_jtpl", function () {
  $(".custom_see_chart_table_wrapper").show();
  $("body").addClass("product_see_chart_open");
});
$("body").on("click", "svg.custom_pdp_cross_icon_jtpl", function () {
  $(".custom_see_chart_table_wrapper").hide();
  $("body").removeClass("product_see_chart_open");
});
$("body").on("click", ".inner_body_close", function () {
  $("body").removeClass("product_see_chart_open");
  $(".custom_see_chart_table_wrapper").hide();
});
function appendBISButton(productId, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    // Remove old button if exists
    const existingButton = container.querySelector('#BIS_trigger');
    if (existingButton) existingButton.remove();
    // Create button
    const button = document.createElement('button');
    button.id = 'BIS_trigger';
    button.type = 'button';
    button.className = 'btn btn--primary btn--solid spo-container uppercase-auto';
    button.style.marginTop = '10px';
    button.style.display = 'block';
    button.setAttribute('aria-label', 'EMAIL WHEN AVAILABLE');
    button.innerText = 'EMAIL WHEN AVAILABLE';
    // Append to container
    container.appendChild(button);
    // Optional: Add click listener to trigger BIS app
    button.addEventListener('click', function() {
        // Replace with your BIS app trigger function
        window.BIS.trigger(productId); 
    });
}



$(".sibling__link_btn").click(function () {

     setTimeout(function(){
  const badges = document.querySelectorAll('.badge');
  if (badges.length > 1) {
    badges[1].style.display = "none";
  }
   },10);


    setTimeout(function(){
  var atcText = document.querySelector(".btn__text_cstm")?.textContent.trim();
  console.log("atcText",atcText);
  var addToCartBtn = document.querySelector(".btn__text[data-add-to-cart-text]");
  if (addToCartBtn && atcText) {
    addToCartBtn.textContent = atcText;
  }
  },1000);

  $(".sibling__link_btn").removeClass("sibling__link--current");
  $(this).addClass("sibling__link--current");
  var isPreorder = $(this).data("preorder");
  var productId = $(this).data("id");
   $(".product_id_change").val(productId);
  var estimateText = $(this).data("estimateShippingText");
   updatePreorderFromSwatch($(this));
    const handle = $(this).data("handle");
    console.log("---handle---",handle);
    // fetch(`/products/${handle}?view=gallery`)
    // .then(r => r.text())
    // .then(html => {
    //   const $html = $(html);
    //   const $newGallery = $html.find(".custom_product__images");
    //   const $currentGallery = $(".custom_product__images");
    //   if ($currentGallery.find(".slick-initialized").length) {
    //     $currentGallery.find(".slick-initialized").slick("unslick");
    //   }
    //   $currentGallery.replaceWith($newGallery);
    //   initProductSlider();
    //   document.querySelectorAll("[data-zoom-wrapper]").forEach((wrapper, index) => {
    //     wrapper.addEventListener("click", (e) => {
    //       e.preventDefault();

    //       // Dispatch custom event with the index of the clicked image
    //       document.dispatchEvent(
    //         new CustomEvent("triggerZoom", { detail: { index } })
    //       );
    //     });
    //   });
    // });


    // fetch(`/products/${handle}?view=gallery`)
    //   .then(r => r.text())
    //   .then(html => {
    //     const $html = $(html);
    //     const $newGallery = $html.find(".custom_product__images");
    //     const $currentGallery = $(".custom_product__images");
    
    //     // Destroy existing slick if initialized
    //     if ($currentGallery.find(".slick-initialized").length) {
    //       $currentGallery.find(".slick-initialized").slick("unslick");
    //     }
    
    //     // Replace old gallery with new
    //     $currentGallery.replaceWith($newGallery);
    //     initProductSlider();
    
    //     // Bind zoom click listeners to **new gallery only**
    //     const newZoomWrappers = $newGallery.find("[data-zoom-wrapper]");
    //     newZoomWrappers.each((index, wrapper) => {
    //       wrapper.addEventListener("click", (e) => {
    //         e.preventDefault();
    
    //         // Trigger zoom for the clicked image in this product only
    //         document.dispatchEvent(
    //           new CustomEvent("triggerZoom", { detail: { index } })
    //         );
    //       });
    //     });
    //   });


    
    fetch(`/products/${handle}?view=gallery`)
  .then(r => r.text())
  .then(html => {

    const $html = $(html);
    const $newGallery = $html.find(".custom_product__images");
    const $currentGallery = $(".custom_product__images");

    if ($currentGallery.find(".slick-initialized").length) {
      $currentGallery.find(".slick-initialized").slick("unslick");
    }

    $currentGallery.replaceWith($newGallery);

    initProductSlider();

 
    document.dispatchEvent(new CustomEvent("product:gallery:updated"));
    $newGallery.find("[data-zoom-wrapper]").each(function(index){

      $(this).on("click", function(e){
        e.preventDefault();

        document.dispatchEvent(
          new CustomEvent("triggerZoom", {
            detail: { index: index }
          })
        );

      });

    });

  document.dispatchEvent(new CustomEvent("product:media:updated"));

});


 var sib_id = $(this).attr("data-sibling-id");
 var sib_variant_id = $(this).attr("data-variant-id");
  var sib_available = $(this).attr("data-available");
 $(".bis-button-container").attr("data-product-id",sib_id);
 if(sib_available){
    $(".bis-button-container").show();
     const container = document.querySelector(`.bis-button-container[data-product-id='${sib_id}']`);
     console.log(sib_variant_id+"===="+sib_id);
     toggleBIS(true);
 }else{
   $(".bis-button-container").hide();
   console.log(sib_variant_id+"===="+sib_id);
    toggleBIS(false);
 }
  var ComparepriceMoney = $(this).attr("data-compare-without-money");
  var ProductriceMoney = $(this).attr("data-without-money");
  var getReviews = $(this).attr("data-review");

  var getfinalsize_badge = $(this).attr("data-final-badge");
  var getfinalsize_badge_div = $(this).attr("data-final-badge-div");

  var getfinalsize_badge_lineitem = $(this).attr("data-final-text");


  var getpReviews = $(this).attr("data-preview");
  var getDesc = $(this).attr("data-desc");
  $(".product-accordion .accordion:eq(0) .accordion-content__entry").html(getDesc);
  var upsellTitle = $(this).attr("data-upsellTitle");
  var upsellPrice = $(this).attr("data-upsellPrice");
  var upsellid = $(this).attr("data-upsellid");
  var upsellImg = $(this).attr("data-upsellImg");
  var upsellHanle = $(this).attr("data-upsellHanle");
  var dataCutline = $(this).data("cutline");
  var dataUrl = $(this).data("url");
  var producttitle = $(this).data("title");
  var productPrice = $(this).data("price");
  var productId = $(this).data("id");
  var productComapreprice = $(this).attr("data-compare-price");
  if (productComapreprice == "") {
    $("s.product__price--strike").hide();
    $("span.product__price--off").hide();
    $("span.product__price--sale").css("color", "#212121");
  } else {
    $("s.product__price--strike").show();
    $("span.product__price--off").show();
    $("span.product__price--sale").css("color", " #d30808");
    var getPercentage = Math.floor(
      ((ComparepriceMoney - ProductriceMoney) * 100) / ComparepriceMoney
    );
    $("span.product__price--off").text(`${getPercentage}% OFF`);
    $(".product__price--off").removeClass("hidden");
    $(".product__block .product__price").html(
      `<span data-product-price="" class="product__price--sale">${productPrice}</span><span class="visually-hidden" data-compare-text="">Regular price</span><s class="product__price--strike" data-compare-price="">
      ${productComapreprice}</s>`
    );
  }
  $(".p_upsell_link").attr("href", upsellHanle);
  $(".upsell_id").val(upsellid);
  $(".product-upsell__image__thumb figure img").attr("srcset", upsellImg);
  $(".product-upsell__image__thumb figure img").attr("src", upsellImg);
  $(".new-price").text(upsellPrice);
  $(".product-upsell__title").text(upsellTitle);
  $(".product__title").text(producttitle);


    if (getfinalsize_badge && getfinalsize_badge !== "") {
      $(".badge").html(getfinalsize_badge_div);
      $(".badge").text(getfinalsize_badge);
      $(".badge").css("display", "inline-block");

    } else {
      $(".badge").html("");
      $(".badge").css("display", "none");

    }


  $("#cstm-final-sale-input").val(getfinalsize_badge_lineitem);

  $(".product__title_bread").text(producttitle);
  $(".review_div").html(" ");
  $(".review_div").html(getReviews);
  $(".product-summary").html(" ");
  $(".product-summary").html(getpReviews);
  $(".radio__legend__value").text(dataCutline);
  $(".dataCutline").val(dataCutline);
  $(".cart-bar__product__title").text(producttitle);
  $(".product__price span").text(productPrice);
  $(".product_id_change").val(productId);
  $(".product__description__content__entry").html(getDesc);
  window.history.pushState("page2", "Title", "/products/" + dataUrl);
});



$("body").on("click", ".main_sub_menu", function () {
  var menuClass = $(this).attr("data-menu");
  $(".sub-menu.jtpl-" + menuClass).slideToggle();
  $(this).toggleClass("arrow-show");
});
var getAttrtrue = $(".index-product.section-padding").attr(
  "data-sticky-enabled"
);
console.log(getAttrtrue);
if (getAttrtrue == "true") {
  $(".product__page .form__wrapper").addClass("is-sticky");
} else {
  $(".product__page .form__wrapper").removeClass("is-sticky");
}
        function initProductSlider() {
        var $slider = $(".custom_product__images.product__images--has-thumbs .product__slides");
        if ($slider.length > 0) {
          // Check if screen is mobile
          if ($(window).width() < 767) { $(".product__page .form__wrapper").removeClass("is-sticky");
            // Initialize only if not already initialized
            if (!$slider.hasClass("slick-initialized")) {
              $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: true,
                adaptiveHeight: true,
              });
            }
          } else {
            // If desktop and slick initialized, destroy it
            if ($slider.hasClass("slick-initialized")) {
              $slider.slick("unslick");
            }
          }
        }
      }
      // Initialize on page load
      $(document).ready(function() {
        initProductSlider();
      });
      // Reinitialize on window resize
      $(window).on("resize", function() {
        initProductSlider();
      });
if ($(window).width() < 767) {

} else {
  // $('.custom_product__images.product__images--has-thumbs .product__slides').unslick();
}
(function () {
  // Add custom code below this line

  $("body").on("click", ".product__thumb .product__thumb__link", function (e) {
    e.preventDefault();

    var getThumbimage = $(this).attr("data-med-id");
    //console.log(getThumbimage);

    $(".custom_product__images .product__slide").each(function () {
      var getProductId = $(this).attr("data-image-id");

      // Check if the IDs match
      if (getProductId == getThumbimage) {
        var gteSlickIndex = $(this).attr("data-slick-index");
        console.log(gteSlickIndex);

        $(
          ".custom_product__images.product__images--has-thumbs .product__slides"
        ).slick("slickGoTo", parseInt(gteSlickIndex)); 
      }
    });
  });

})();

$(document).on("click", "#second_search .icon.icon-search", function(){
    $("body").addClass("search-overlay-new");
});

$(document).on("click", ".search-popdown__close__button", function() {
    setTimeout(function() {
        $("body").removeClass("search-overlay-new");
    }, 500); 
});

window.addEventListener('scroll', () => {
  const section = document.getElementById('BrickSection--template--18874880688303__section_custom_content_QFwrg6');
  const header = document.querySelector('.header__wrapper.js__header__stuck.js__header__stuck__backdrop');

  if (!section || !header) return;

  const sectionRect = section.getBoundingClientRect();

  if (sectionRect.bottom <= 0) {
    header.classList.add('new-header-transparent');
    header.removeAttribute("data-header-transparent");
   
    header.setAttribute("data-header-transparent", "false");
  } else {
    header.classList.remove('new-header-transparent');
    header.setAttribute("data-header-transparent","true");
  }

});

$(document).ready(function () {
  if ($(window).width() < 758) {
    var headerHeight = $("header.theme__header").height();

  }
  if ($(window).width() < 684) {
    $(document).on("click", ".sliderule__wrapper", function (e) {
      e.stopPropagation();
      $(this).find("ul.sub-menu.drop-down").css("display", "block");
    });
  }
  document.querySelectorAll('body *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6)').forEach(el => {
  const text = el.textContent.trim();
  if (text && text === text.toUpperCase()) {
    console.log("UpperCase");
    el.classList.add('uppercase-auto');
  }
});
});


window.__PDP_STATE__ = {
  preorder: false,
  available: true
};

//feb 4 jtpl
function applyPreorderState({
  preorder = false,
  available = true,
  preorderText = "Pre Order",
  estimateShippingText = "",
  variantId
}) {

window.__PDP_STATE__ = {
  preorder,
  available
};


  const submitBtn = document.querySelector('.product-form button[type="submit"]');
  const btnTextEl = submitBtn?.querySelector('[data-atc-text], .btn__text_cstm');
  const preorderInput = document.getElementById('preorder-input');
  const estimateInput = document.getElementById('estimate-input');
  const estimateWrapper = document.querySelector('.custom_preorder_text_product_wrapper');
  const estimateTextEl = document.querySelector('.estimate-shipping-text');
var subVariant = document.querySelector('button.sibling__link_btn.sibling__link--current').getAttribute("data-variant-id");
var subProd = document.querySelector('button.sibling__link_btn.sibling__link--current').getAttribute("data-sibling-id");
var subProdJson = document.querySelector('button.sibling__link_btn.sibling__link--current .product-json').innerHTML;

  if (!submitBtn) return;
  console.log("bisBtn-------"+subVariant);
  console.log("bisBtn-------"+subProd);


  /* START drop hint */
  // document.addEventListener("click", function (e) {
  // const btn = e.target.closest("button.sibling__link_btn");
  //   if (!btn) return;
  //   const variantId = btn.getAttribute("data-id");
  //   const variant_handle = btn.getAttribute('data-handle')
  //   console.log("Updated variant hint ID:", variantId);
  //   console.log("Updated variant hint handle:",variant_handle)
  //   if (window.dropahintApp) {
  //     // alert('----first----');
  //     window.dropahintApp.variantId = variantId;
  //     if (window.dropahintApp.ProductJSON) {
  //       // alert('----second----');
  //       window.dropahintApp.ProcessProduct();
  //     }
  //   }

  //   window.customSelectedProduct = {
  //     productHandle: variant_handle,
  //     variantId: variantId
  //   };
  // });



  // document.addEventListener("click", function (e) {
  //   const swatchBtn = e.target.closest("button.sibling__link_btn");
  //   if (swatchBtn) {
  //     const variantId = swatchBtn.getAttribute("data-id");
  //     const variantHandle = swatchBtn.getAttribute("data-handle");
  //     const productName = swatchBtn.getAttribute("data-product-title");
  //     const productImage = swatchBtn.getAttribute("data-product-image");
  //     const popupNameElement = document.querySelector("#hint_modal .product_name");
  //     const popupImageElement = document.querySelector("#hint_modal .productImageDropahint");
  //     if (popupNameElement) {
  //       popupNameElement.textContent = productName;
  //     }
  //     if (popupImageElement && productImage) {
  //       popupImageElement.src = productImage;
  //     }

  //     if (window.dropahintApp) {
  //       window.dropahintApp.variantId = variantId;
  //       if (window.dropahintApp.ProcessProduct) {
  //         window.dropahintApp.ProcessProduct();
  //       }
  //     }

  //     window.customSelectedProduct = {
  //       productHandle: variantHandle,
  //       variantId: variantId
  //     };
  //     console.log("Popup updated for product name:", productName);
  //     console.log("Popup updated for product image:", productImage);
  //   }
  // });



  document.addEventListener("click", function (e) {
    const swatchBtn = e.target.closest("button.sibling__link_btn");
    if (swatchBtn) {
        const variantId = swatchBtn.getAttribute("data-id");
        const variantHandle = swatchBtn.getAttribute("data-handle");
        const productName = swatchBtn.getAttribute("data-product-title");
        const productImage = swatchBtn.getAttribute("data-product-image");
        const popupNameElement = document.querySelector("#hint_modal .product_name");
        const popupImageElement = document.querySelector("#hint_modal .productImageDropahint");
        const popupImageElement_success = document.querySelector("#hint_modal_closing .productImageDropahint");
        if (popupNameElement) popupNameElement.textContent = productName;
        if (popupImageElement && productImage) popupImageElement.src = productImage;
        if (popupImageElement_success && productImage) popupImageElement_success.src = productImage;
        if (window.dropahintApp) {
            window.dropahintApp.variantId = variantId;
            window.dropahintApp.productHandle = variantHandle;
            window.dropahintApp.variantName = productName;
            window.dropahintApp.variantImage = productImage;
            if (window.dropahintApp.ProductJSON) {
                window.dropahintApp.ProductJSON.variants.forEach(v => {
                    if (v.id == variantId) {
                        window.dropahintApp.currentVariant = v;
                    }
                });
            }
            if (typeof window.dropahintApp.ProcessProduct === "function") {
                window.dropahintApp.ProcessProduct();
            }
        }
        const sendBtn = document.querySelector("#u_content_button_1_sendHint a");
        if (sendBtn) {
            let currentUrl = new URL(sendBtn.href, window.location.origin);
            currentUrl.searchParams.set('variant', variantId);
            currentUrl.searchParams.set('handle', variantHandle);
            currentUrl.searchParams.set('image', productImage);
            currentUrl.searchParams.set('name', productName);
            sendBtn.href = currentUrl.toString();
        }
        const hiddenVariantInput = document.querySelector('input[name="variant_id"]');
        if (hiddenVariantInput) {
          alert();
            hiddenVariantInput.value = variantId;
        }
        window.customSelectedProduct = {
            productHandle: variantHandle,
            variantId: variantId,
            productName: productName,
            productImage: productImage
        };
        console.log("Popup updated for product name:", productName);
        console.log("Popup updated for product image:", productImage);
        console.log("SUCCESS: Sent data updated to Variant ID:", variantId);
    }
  });

// const observer = new MutationObserver(function () {
//   if (!window.customSelectedProduct) return;
//   const successPopup = document.querySelector(".u-popup-content");
//   if (successPopup) {
//     const img = successPopup.querySelector(".productImageDropahint");
//     if (img) {
//       img.src = window.customSelectedProduct.productImage;
//       console.log("Success popup image updated");
//     }
//   }
// });
// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// }); 


document.addEventListener('click', function (event) {
  // Replace '.drop-hint-send-button' with the actual class you found
  if (event.target.closest('#u_content_button_1_sendHint')) {
    // alert();
    // This fires when the user clicks Send
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'drop_hint_sent',
      'product_name': meta.product.variants[0].name // Shopify's native product object
    });
  }
}, false);


// (function() {
//     const originalFetch = window.fetch;
//     window.fetch = function() {
//         const url = arguments[0];
//         const options = arguments[1];
//         if (typeof url === 'string' && url.includes('drop-a-hint')) {
//             console.log("DROP HINT DATA DETECTED!", "color: green; font-weight: bold; font-size: 14px;");
//             console.log("Target URL:", url);          
//             if (options && options.body) {
//                 try {
//                     const payload = JSON.parse(options.body);
//                     console.log("FORM DATA (JSON):", payload);
//                 } catch (e) {
//                     console.log("FORM DATA (Raw):", options.body);
//                 }
//             }
//         }
//         return originalFetch.apply(this, arguments);
//     };
//     console.log("Monitoring Active: Ab form submit");
// })();


// (function() {
//     const originalFetch = window.fetch;
//     window.fetch = function() {
//         let url = arguments[0];
//         let options = arguments[1];
//         if (typeof url === 'string' && url.includes('drop-a-hint') && options && options.body) {
//             try {
//                 let payload = JSON.parse(options.body);
//                 if (window.customSelectedProduct) {
//                     console.log("FORCING SELECTED DATA INTO REQUEST...", "color: #ff9900; font-weight: bold;");
//                     payload.product_name = window.customSelectedProduct.productName;
//                     payload.product_image = window.customSelectedProduct.productImage;
//                     payload.variantId = window.customSelectedProduct.variantId;
//                     if (window.customSelectedProduct.productHandle) {
//                         payload.link = window.location.origin + "/products/" + window.customSelectedProduct.productHandle;
//                     }
//                     options.body = JSON.stringify(payload);
//                     arguments[1] = options; 

//                     console.log("%c DATA PATCHED SUCCESSFULLY:", "color: #00ff00;", payload);
//                 }
//             } catch (e) {
//                 console.error("Error patching payload:", e);
//             }
//         }
//         return originalFetch.apply(this, arguments);
//     };
//     console.log("Fix Applied");
// })();


(function() {
    const originalFetch = window.fetch;
    window.fetch = function() {
        let url = arguments[0];
        let options = arguments[1];

        // Sirf Drop-a-hint ki request pakadni hai jisme body ho
        if (typeof url === 'string' && url.includes('drop-a-hint') && options && options.body) {
            try {
                let payload = JSON.parse(options.body);

                // Agar user ne swatch click kiya hai
                if (window.customSelectedProduct) {
                    console.log("%c🔄 Updating Name & Image Only...", "color: #3498db; font-weight: bold;");

                    // SIRF ye do cheezein update hongi
                    if (window.customSelectedProduct.productName) {
                        payload.product_name = window.customSelectedProduct.productName;
                    }
                    if (window.customSelectedProduct.productImage) {
                        payload.product_image = window.customSelectedProduct.productImage;
                    }

                    // Wapas pack karke bhej do
                    options.body = JSON.stringify(payload);
                    arguments[1] = options; 

                    console.log("Patched Payload:", "color: #2ecc71;", {
                        name: payload.product_name,
                        image: payload.product_image
                    });
                }
            } catch (e) {
                // Agar JSON parse fail ho toh original request jaane do
            }
        }
        return originalFetch.apply(this, arguments);
    };
    console.log("Ready");
})();


  /* END drop hint */



  /* RESET */
  submitBtn.disabled = false;
  submitBtn.dataset.preorder = "false";
  btnTextEl.textContent = "Add to Cart";
  toggleBIS(false);


  if (preorderInput) preorderInput.value = "";
  if (estimateInput) estimateInput.value = "";

  if (estimateWrapper) estimateWrapper.style.display = "none";
  if (estimateTextEl) estimateTextEl.textContent = "";

  /* SOLD OUT */
  if (!available) {
    btnTextEl.textContent = "Sold Out";
    submitBtn.disabled = true;

    toggleBIS(true);
    return;
    

  }

  /* PREORDER */
  if (preorder) {
    btnTextEl.textContent = preorderText || "Pre Order";
    submitBtn.dataset.preorder = "true";
    if (preorderInput) preorderInput.value = "Yes";
    if (estimateInput) estimateInput.value = estimateShippingText || "";
    toggleBIS(false);


    if (estimateWrapper && estimateTextEl && estimateShippingText) {
      estimateTextEl.textContent = estimateShippingText;
      estimateWrapper.style.display = "block";
    }
  }
}


$(document).ready(function () {
  const initialDataEl = document.getElementById("initial-product-data");

  if (initialDataEl) {
    const data = JSON.parse(initialDataEl.textContent);
    applyPreorderState(data);
  }
});

function updatePreorderFromSwatch($el) {
  const variantId = parseInt($el.attr("data-id"), 10); 

  applyPreorderState({
    preorder: $el.attr("data-preorder") === "true",
    available: $el.attr("data-available") === "true",
    preorderText: $el.attr("data-pre-order-text"),
    estimateShippingText: $el.attr("data-estimate-shipping-text"),
    variantId
  });
}


// 3️⃣ MutationObserver (GLOBAL, runs once)
initBISObserver();
//end-feb 4 jtpl


// function toggleBIS(show) {
//   var variantId = document.querySelector('button.sibling__link_btn.sibling__link--current').getAttribute("data-variant-id");
// var productHandle = document.querySelector('button.sibling__link_btn.sibling__link--current').getAttribute("data-sibling-id");
// var subProdJson = document.querySelector('button.sibling__link_btn.sibling__link--current .product-json').innerHTML;


//   const submitBtn = document.querySelector('.product-form button[type="submit"]');
//   if (!submitBtn) return;

//   const oldBIS = document.querySelector('#BIS_trigger');
//   if (oldBIS) oldBIS.remove();

//   variantId = Number(variantId);
// console.log("BIS___"+variantId+"===="+productHandle);
// if(show == false){
// return false;
// }
//     var bisBtn = document.createElement('button');
//     bisBtn.id = 'BIS_trigger';
//     bisBtn.type = 'button';
//     bisBtn.className = 'btn btn--primary btn--solid spo-container uppercase-auto';
//     bisBtn.style.marginTop = '10px';
//     bisBtn.setAttribute('aria-label', 'EMAIL WHEN AVAILABLE');
//     console.log(variantId)
//     console.log(productHandle)
//     // These are important for BIS
//    // bisBtn.setAttribute('data-variant-id', variantId);
//     bisBtn.setAttribute('data-product-handle', productHandle);

//     bisBtn.innerText = 'EMAIL WHEN AVAILABLE';

//     // Insert after Add to Cart
//     submitBtn.insertAdjacentElement('afterend', bisBtn);
// console.log(window.BIS)
//     // Initialize BIS for this button
//     if (window.BIS && BIS.create) {
//       BIS.create(bisBtn); // tells BIS this button exists
//     }
  
//     const newBISConfig = {
//     product: subProdJson,
//     shop: BIS.Config.shop,
//     button: BIS.Config.button,
//   };

//    BIS.create(bisBtn, newBISConfig);

//   bisBtn.style.display = show ? 'block' : 'none';
//   const firstVariant = subProdJson.variants[0];
//       // Open BIS popup on click
//       bisBtn.addEventListener("click", function (e) {
//         e.preventDefault();
//         if (firstVariant) {
//           window.BIS.popup.form.selectVariant(firstVariant);
//         }
//       });
// }
//test422424


// function toggleBIS(show) {
//   const currentBtn = document.querySelector('button.sibling__link_btn.sibling__link--current');
//   const submitBtn = document.querySelector('.product-form button[type="submit"]');
  
//   if (!submitBtn || !currentBtn) return;

//   // 1. Clean up old buttons to prevent event listener stacking
//   const oldBIS = document.querySelector('#BIS_trigger');
//   if (oldBIS) oldBIS.remove();

//   if (!show) return;

//   // 2. Create the UI button
//   const bisBtn = document.createElement('button');
//   bisBtn.id = 'BIS_trigger';
//   bisBtn.type = 'button';
//   bisBtn.className = 'btn btn--primary btn--solid spo-container uppercase-auto';
//   bisBtn.style.marginTop = '10px';
//   bisBtn.style.display = 'block';
//   bisBtn.innerText = 'EMAIL WHEN AVAILABLE';
  
//   submitBtn.insertAdjacentElement('afterend', bisBtn);

//   // 3. Handle the click event without passing the full product object
//   bisBtn.addEventListener("click", function (e) {
//     e.preventDefault();
    
//     // Get the ID from the button's data attribute directly
//     const variantId = parseInt(currentBtn.getAttribute("data-id"));

//     if (window.BIS) {
//       console.log("BIS: Triggering notification for ID:", variantId);
      
//       // We use BIS.trigger directly. 
//       // This bypasses the serialization of the product object.
//       try {
//         window.BIS.trigger(variantId);
//       } catch (err) {
//         // Fallback for older versions of the BIS app
//         window.BIS.popup.show({ variantId: variantId });
//       }
//     } else {
//       console.error("Back In Stock app not loaded on page.");
//     }
//   });
// }

// function toggleBIS(show) {
//   const currentBtn = document.querySelector('button.sibling__link_btn.sibling__link--current');
//   const submitBtn = document.querySelector('.product-form button[type="submit"]');
  
//   if (!submitBtn || !currentBtn) return;

//     const oldBISFrame = document.querySelector('#BIS_frame');
//   if (oldBISFrame) oldBISFrame.remove();

//   // 1. Remove old button
//   const oldBIS = document.querySelector('#BIS_trigger');
//   if (oldBIS) oldBIS.remove();

//   if (!show) return;

//   // 2. Get the Variant ID
//   const variantId = currentBtn.getAttribute("data-id");

//   // 3. Create a fresh button with the exact attributes the BIS app looks for
//   const bisBtn = document.createElement('button');
//   bisBtn.id = 'BIS_trigger';
//   bisBtn.type = 'button';
//   bisBtn.className = 'btn btn--primary btn--solid BIS_trigger';
//   bisBtn.style.marginTop = '10px';
//   bisBtn.style.display = 'block';
//   bisBtn.innerText = 'EMAIL WHEN AVAILABLE';
  
//   // Set these data attributes so the BIS script can "see" the target
//   bisBtn.setAttribute('data-variant-id', variantId);
//   bisBtn.setAttribute('data-product-handle', currentBtn.getAttribute('data-handle'));

//   submitBtn.insertAdjacentElement('afterend', bisBtn);

//   // 4. Force BIS to recognize this new button
//   if (window.BIS && typeof window.BIS.refresh === 'function') {
//     window.BIS.refresh(); 
//   }

//   // 5. Direct Event Listener (Bypassing the crashing 'show' property)
//   bisBtn.addEventListener("click", function (e) {
//     e.preventDefault();
//     console.log(window.BIS);
//      console.log(window.BIS.popup);
//      // alert("heree");
   
//     // Check if the specialized popup exists, otherwise use the global trigger
//     if (window.BIS && window.BIS.popup) {
//      // alert("first");   
//         window.BIS.popup.show({ variantId: parseInt(variantId) });

//     } else if (window.BIS) {
//         window.BIS.refresh();
//         // This is the most stable method as it doesn't rely on the 'popup' object
//         window.BIS.trigger(parseInt(variantId));
        
//     }
//   });
// }





// function toggleBIS(show) {
//   const currentBtn = document.querySelector('button.sibling__link_btn.sibling__link--current');
//   const submitBtn = document.querySelector('.product-form button[type="submit"]');
  
//   if (!submitBtn || !currentBtn) return;

//   // 1. Just hide/show the button, don't keep removing/recreating it if possible
//   let bisBtn = document.querySelector('#BIS_trigger');
  
//   if (!show) {
//     if (bisBtn) bisBtn.style.display = 'none';
//     return;
//   }

//   // 2. If button doesn't exist, create it once
//   if (!bisBtn) {
//     bisBtn = document.createElement('button');
//     bisBtn.id = 'BIS_trigger';
//     bisBtn.type = 'button';
//     bisBtn.className = 'btn btn--primary btn--solid BIS_trigger';
//     bisBtn.style.marginTop = '10px';
//     bisBtn.innerText = 'EMAIL WHEN AVAILABLE';
//     submitBtn.insertAdjacentElement('afterend', bisBtn);
//   }

//   // 3. Update the button's data for the current variant
//   const variantId = currentBtn.getAttribute("data-id");
//   bisBtn.style.display = 'block';
//   bisBtn.setAttribute('data-variant-id', variantId);
//   bisBtn.setAttribute('data-product-handle', currentBtn.getAttribute('data-handle'));

//   // 4. THE FIX: Clear the "Click" listener and re-add it fresh
//   bisBtn.onclick = function (e) {
//     e.preventDefault();

//       // const iframes = document.querySelectorAll('#BIS_frame');
//       // const cstm_btn_handle =  bisBtn.getAttribute('data-product-handle', currentBtn.getAttribute('data-handle'));
//       // iframes.forEach((iframe) => {
//       //   const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
//       //   if (!iframeDoc || !iframeDoc.body) return;
//       //   const productNameEl = iframeDoc.querySelector('.product-name');
//       //   if (productNameEl) {
//       //     const rawName = productNameEl.textContent.trim();
//       //     const nicheName = rawName
//       //       .toLowerCase()       
//       //       .replace(/[^a-z0-9\s-]/g, '') 
//       //       .replace(/\s+/g, '-')   
//       //       .replace(/-+/g, '-');     

//       //     alert('cstm_popup_prod_name ' + nicheName);
//       //   }
//       // });
//       // alert('---current button handle--- ' + ' ' + cstm_btn_handle)


//       // all BIS iframes (same ID reused)
//       const iframes = document.querySelectorAll('#BIS_frame');
//       // current clicked button handle
//       const cstm_btn_handle = bisBtn.getAttribute('data-product-handle');
//       setTimeout(() => {
//         iframes.forEach((iframe) => {
//           const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
//           if (!iframeDoc || !iframeDoc.body) {
//             iframe.style.display = 'none';
//             return;
//           }
//           const productNameEl = iframeDoc.querySelector('.product-name');
//           if (!productNameEl) {
//             iframe.style.display = 'none';
//             return;
//           }
//           // convert product name → handle style
//           const rawName = productNameEl.textContent.trim();
//           const nicheName = rawName
//             .toLowerCase()
//             .replace(/[^a-z0-9\s-]/g, '')
//             .replace(/\s+/g, '-')
//             .replace(/-+/g, '-');

//           if (nicheName === cstm_btn_handle) {
//             iframe.style.display = 'block'; // or flex
//             console.log('MATCHED iframe:', nicheName);
//           } else {
//             iframe.style.display = 'none';
//           }
//         });
//       }, 1000); 
    
//     if (window.BIS) {
//       const vId = parseInt(variantId);
      
//       // Step A: Manually update the BIS internal variant tracking
//       window.BIS.variantId = vId; 
      
//       // Step B: Tell the popup it is NOT showing (resets the lock)
//       if (window.BIS.popup) {
//         window.BIS.popup.isShowing = false;
//       }

//       // Step C: Trigger
//       window.BIS.trigger(vId);
      
//       // Step D: If the frame is just hidden, force it to show
//       // setTimeout(() => {
//       //   const frame = document.querySelector('#BIS_frame');
//       //   if (frame) frame.style.setProperty('display', 'block', 'important');
//       // }, 100);

//       setTimeout(() => {
//       const allFrames = document.querySelectorAll('#BIS_frame');
      
//       if (allFrames.length > 0) {
//         // 1. Pehle saare frames ko hide kar do
//         allFrames.forEach(f => {
//           f.style.setProperty('display', 'none', 'important');
//           f.style.setProperty('opacity', '0', 'important');
//           f.style.setProperty('pointer-events', 'none', 'important');
//         });

//         // 2. Sirf sabse naye (current) frame ko dikhao
//         const currentFrame = allFrames[allFrames.length - 1];
//         currentFrame.style.setProperty('display', 'block', 'important');
//         currentFrame.style.setProperty('opacity', '1', 'important');
//         currentFrame.style.setProperty('pointer-events', 'auto', 'important');
//         currentFrame.style.setProperty('visibility', 'visible', 'important');
//       }
//     }, 150); // Thoda sa delay badhaya hai stability ke liye

//         }
//       };

//   // Tell BIS to look at the new button data
//   if (window.BIS && typeof window.BIS.refresh === 'function') {
//     window.BIS.refresh();
//   }
// }




function toggleBIS(show) {
  const currentBtn = document.querySelector('button.sibling__link_btn.sibling__link--current');
  const submitBtn = document.querySelector('.product-form button[type="submit"]');
  
  if (!submitBtn || !currentBtn) return;

  //   const oldBISFrame = document.querySelector('#BIS_frame');
  // if (oldBISFrame) oldBISFrame.remove();

  // 1. Remove old button
  const oldBIS = document.querySelector('#BIS_trigger');
  if (oldBIS) oldBIS.remove();

  if (!show) return;

  // 2. Get the Variant ID
  const variantId = currentBtn.getAttribute("data-id");

  // 3. Create a fresh button with the exact attributes the BIS app looks for
  const bisBtn = document.createElement('button');
  bisBtn.id = 'BIS_trigger';
  bisBtn.type = 'button';
  bisBtn.className = 'btn btn--primary btn--solid BIS_trigger';
  bisBtn.style.marginTop = '10px';
  bisBtn.style.display = 'block';
  bisBtn.innerText = 'EMAIL WHEN AVAILABLE';
  
  // Set these data attributes so the BIS script can "see" the target
  bisBtn.setAttribute('data-variant-id', variantId);
  bisBtn.setAttribute('cstm-data-product-name',  currentBtn.getAttribute('data-product-title'));
  bisBtn.setAttribute('data-product-handle', currentBtn.getAttribute('data-handle'));

  submitBtn.insertAdjacentElement('afterend', bisBtn);

  // 4. Force BIS to recognize this new button
  if (window.BIS && typeof window.BIS.refresh === 'function') {
    window.BIS.refresh(); 
  }

  // 5. Direct Event Listener (Bypassing the crashing 'show' property)
  bisBtn.addEventListener("click", function (e) {
    e.preventDefault();


    // all BIS iframes (same ID reused)
      const iframes = document.querySelectorAll('#BIS_frame');
      // current clicked button handle
      const cstm_btn_handle = bisBtn.getAttribute('data-product-handle');

      const cstm_btn_product_name = bisBtn.getAttribute('cstm-data-product-name');

      setTimeout(() => {
        iframes.forEach((iframe) => {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!iframeDoc || !iframeDoc.body) {
            iframe.style.display = 'none';
            return;
          }
          const productNameEl = iframeDoc.querySelector('.product-name');
          if (!productNameEl) {
            iframe.style.display = 'none';
            return;
          }
          // convert product name → handle style
          const rawName = productNameEl.textContent.trim();
          const nicheName = rawName
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');

            console.log(nicheName +"=========="+ cstm_btn_handle);
            console.log(rawName +"==========="+ cstm_btn_product_name);

            if (rawName === cstm_btn_product_name) {
          // if (nicheName === cstm_btn_handle) {
            iframe.style.display = 'block'; // or flex
            console.log('MATCHED iframe:', nicheName);
          } else {
            iframe.style.display = 'none';
          }
        });
      }, 800); 


    console.log(window.BIS);
     console.log(window.BIS.popup);
     // alert("heree");
   
    // Check if the specialized popup exists, otherwise use the global trigger
    if (window.BIS && window.BIS.popup) {
     // alert("first");   
        window.BIS.popup.show({ variantId: parseInt(variantId) });

    } else if (window.BIS) {
        window.BIS.refresh();
        // This is the most stable method as it doesn't rely on the 'popup' object
        window.BIS.trigger(parseInt(variantId));
        
    }
  });
}



function initBISObserver() {
  const observer = new MutationObserver(() => {
    const bisBtn = document.querySelector('#BIS_trigger, .BIS_trigger');
    if (!bisBtn) return;

    const state = window.__PDP_STATE__ || {};
    const { preorder, available } = state;

    if (preorder) {
      bisBtn.style.display = "none";
      return;
    }

    if (!available) {
      bisBtn.style.display = "block";
      return;
    }

  
    bisBtn.style.display = "none";
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}



// Wait until DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Listen for clicks on sibling swatch buttons
 document.body.addEventListener("click", (e) => {
  const btn = e.target.closest(".sibling__link_btn");
  if (!btn) return;

  const available = btn.dataset.available === "true";
  const preorder = btn.dataset.preorder === "true";
  const variantId = btn.dataset.id;

  console.log("Sibling clicked:", btn.dataset.title, "Available:", available, "Preorder:", preorder);

  // Update PDP state
  window.__PDP_STATE__ = { preorder, available, id: variantId };

  // Show/hide BIS button
  toggleBIS(!available);
});
});






// function reinitZoomSibling() {
//     const container = document.querySelector(".custom_product__images");
//     if (!container) return;

//     // Destroy old instance if exists
//     if (window.zoomInstance && typeof window.zoomInstance.destroy === "function") {
//         window.zoomInstance.destroy();
//     }

//     // Create new Zoom instance
//     window.zoomInstance = new Zoom({
//         container: container
//     });
// }

    // fetch(`/products/${handle}?view=gallery`)
    // .then(r => r.text())
    // .then(html => {
    //     const $html = $(html);
    //     const $newGallery = $html.find(".custom_product__images");
    //     const $currentGallery = $(".custom_product__images");

    //     // Replace only inner HTML
    //     $currentGallery.html($newGallery.html());

    //     // Re-init slider
    //     initProductSlider();

    //     // Re-init zoom
    //     reinitZoomSibling();
    // });







